import { CInput } from "./components/CInput.js";
import { CButton } from "./components/CButton.js";
import { CCheckbox } from "./components/CCheckbox.js";
import { CRadioGroup } from "./components/CRadioGroup.js";
import { CToggle } from "./components/CToggle.js";
import { CText } from "./components/CText.js";
import { CBadge } from "./components/CBadge.js";
import { CAlert } from "./components/CAlerts.js";
import { CProgress } from "./components/CProgress.js";

// 👇 Comment for development and uncomment when building
import './tempora-ui.css'; 

import { iniToolTips, setupPopupTriggers } from "./listeners/Listener.js";

const TemporaUI = {
  version: "1.0.0",
  init() {
    console.log("%c TemporaUI Initialized 🚀", "color: #4E41FF; font-size: 20px;");
  }
};

// Make it global (this fixes your issue)
window.TemporaUI = TemporaUI;
window.addEventListener('DOMContentLoaded', () => {
  iniToolTips();
  setupPopupTriggers();
});

// Auto-init (optional)
TemporaUI.init();

// Still export (good practice if bundled later)
export default TemporaUI;